import { OrderDoc, OrderStatusCode } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';

import { observeOrders } from 'src/utils/firebase/firebase-short-cut';

interface UseRecentValidOrdersOptions {
  limit?: number;
}

export const useRecentValidOrders = (storeId: string | null, options: UseRecentValidOrdersOptions = {}) => {
  const { limit = 10 } = options;
  const [orders, setOrders] = useState<OrderDoc[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!storeId) {
      setOrders([]);
      return;
    }

    setIsLoading(true);

    const subscription = observeOrders(
      [
        ['storeId', '==', storeId],
        ['orderStatus', 'in', [OrderStatusCode.SUBMITTED, OrderStatusCode.ACCEPTED, OrderStatusCode.DELIVERED]],
      ],
      {
        // SUBMITTED 주문은 `date` 필드가 null이라 orderBy에서 제외됨 → orderDate로 정렬
        sortKey: 'orderDate',
        orderBy: 'desc',
        limit,
      },
    ).subscribe({
      next: (docs) => {
        setOrders(docs);
        setIsLoading(false);
      },
      error: (err) => {
        console.error('Failed to fetch recent valid orders:', err);
        setIsLoading(false);
      },
    });

    return () => subscription.unsubscribe();
  }, [storeId, limit]);

  return { orders, isLoading };
};
